import { apiService } from 'services'

import { EventResponse } from 'types'

const URL = '/babies'

export interface DateParams {
  startTime: string
  endTime: string
}

const getEvents = async (babyId: number, params?: DateParams) =>
  apiService.get<EventResponse>(`${URL}/${babyId}/events/calendar`, { params })

const getMoreEvents = async (babyId: number, params?: DateParams) =>
  apiService.get<EventResponse>(`${URL}/${babyId}/events`, {
    params,
  })

export const ChartApi = { getEvents, getMoreEvents }
